/* (c) Alpas Made LLC. All rights reserved. */
/* Kinetic Carving Design Lab SPA -- seed data (designs + makers) */
// Shared data for the Kinetic Carving Design Lab prototype
// All images from Unsplash/Pexels (CNC, wood, skulls, norse, tactical)

window.KC_DATA = (() => {
  const CATS = ['Wall Art', 'Skulls', 'Military', 'Norse', 'Wildlife', 'Flags', 'Tactical'];
  const STATUSES = ['New', 'Rising', 'Popular', 'In Production', 'Completed'];

  const DESIGNS = [
    {
      id: 'd1',
      title: 'Stag Skull with Runes',
      author: 'ironhand_carves',
      authorId: 'u2',
      category: 'Norse',
      status: 'Rising',
      votes: 62,
      threshold: 75,
      createdDays: 4,
      image: 'https://images.unsplash.com/photo-1567613003436-a4ed3c834c20?w=1200&q=80',
      description: 'Antlered skull ringed with Elder Futhark. Targeting walnut base with bone-white fill in the runes. Meant for above-the-desk or mantel scale -- roughly 18×14".',
      comments: 23,
      bookmarked: false,
    },
    {
      id: 'd2',
      title: 'M1 Garand Silhouette',
      author: 'garage_goblin',
      authorId: 'u3',
      category: 'Military',
      status: 'Popular',
      votes: 71,
      threshold: 75,
      createdDays: 9,
      image: 'https://images.unsplash.com/photo-1584727638096-042c45049ebe?w=1200&q=80',
      description: 'Clean profile silhouette of the M1, with stamped serial-number detail along the lower band. White oak, dark char contrast.',
      comments: 41,
      bookmarked: true,
    },
    {
      id: 'd3',
      title: 'Mjölnir on Shield Wall',
      author: 'nordhammer',
      authorId: 'u4',
      category: 'Norse',
      status: 'In Production',
      votes: 98,
      threshold: 75,
      createdDays: 21,
      image: 'https://images.unsplash.com/photo-1606925207923-c70c0bc8fe7c?w=1200&q=80',
      description: 'Hammer framed by overlapping round shields. Production starts next week -- first batch limited to 50 pieces, numbered.',
      comments: 87,
      bookmarked: true,
    },
    {
      id: 'd4',
      title: 'Broadhead Elk',
      author: 'pinecone_pete',
      authorId: 'u5',
      category: 'Wildlife',
      status: 'New',
      votes: 18,
      threshold: 75,
      createdDays: 1,
      image: 'https://images.unsplash.com/photo-1605478371310-a9f1e96b4ff4?w=1200&q=80',
      description: 'Bull elk silhouette with a broadhead arrow forming the crown of the antlers. Hunter-bowhunter crossover audience.',
      comments: 6,
      bookmarked: false,
    },
    {
      id: 'd5',
      title: 'Don\u2019t Tread -- Coiled',
      author: 'liberty_shop',
      authorId: 'u6',
      category: 'Flags',
      status: 'Rising',
      votes: 44,
      threshold: 75,
      createdDays: 6,
      image: 'https://images.unsplash.com/photo-1517511620798-cec17d428bc0?w=1200&q=80',
      description: 'Gadsden interpretation with heavy negative-space coils. No text -- the form does the talking.',
      comments: 19,
      bookmarked: false,
    },
    {
      id: 'd6',
      title: 'Ranger Tab Compass',
      author: 'rgr_woodworks',
      authorId: 'u7',
      category: 'Tactical',
      status: 'Rising',
      votes: 57,
      threshold: 75,
      createdDays: 3,
      image: 'https://images.unsplash.com/photo-1495364141860-b0d03eccd065?w=1200&q=80',
      description: 'Compass rose with Ranger tab nested in the N point. Subtle grid in the background for a map feel.',
      comments: 14,
      bookmarked: false,
    },
    {
      id: 'd7',
      title: 'Wolf Pack Under Yggdrasil',
      author: 'nordhammer',
      authorId: 'u4',
      category: 'Norse',
      status: 'Popular',
      votes: 88,
      threshold: 75,
      createdDays: 16,
      image: 'https://images.unsplash.com/photo-1564466809058-bf4114d55352?w=1200&q=80',
      description: 'Three wolves beneath the World Tree, roots wrapping the baseline. Heavier piece -- 24" minimum.',
      comments: 52,
      bookmarked: false,
    },
    {
      id: 'd8',
      title: 'Bearded Sailor Skull',
      author: 'deadreckoning',
      authorId: 'u8',
      category: 'Skulls',
      status: 'New',
      votes: 11,
      threshold: 75,
      createdDays: 2,
      image: 'https://images.unsplash.com/photo-1555661530-68c8e98db4e6?w=1200&q=80',
      description: 'Skull with a carved beard and anchor-cross on forehead. Old-school tattoo flash, CNC\'d heavy.',
      comments: 3,
      bookmarked: false,
    },
    {
      id: 'd9',
      title: 'Tomahawk & Feathers',
      author: 'rgr_woodworks',
      authorId: 'u7',
      category: 'Military',
      status: 'Rising',
      votes: 49,
      threshold: 75,
      createdDays: 5,
      image: 'https://images.unsplash.com/photo-1580136608595-5c0e6b5a3020?w=1200&q=80',
      description: 'Crossed tomahawks with eagle feathers. Carved from red oak with torched edges.',
      comments: 11,
      bookmarked: false,
    },
    {
      id: 'd10',
      title: 'Grizzly Paw Swipe',
      author: 'pinecone_pete',
      authorId: 'u5',
      category: 'Wildlife',
      status: 'Popular',
      votes: 80,
      threshold: 75,
      createdDays: 12,
      image: 'https://images.unsplash.com/photo-1525869916826-0bcab7f48700?w=1200&q=80',
      description: 'Three-claw swipe breaking through timber planks. 3D relief carving, deep cuts.',
      comments: 33,
      bookmarked: true,
    },
    {
      id: 'd11',
      title: 'Thin Red Line Axe',
      author: 'garage_goblin',
      authorId: 'u3',
      category: 'Tactical',
      status: 'Completed',
      votes: 142,
      threshold: 75,
      createdDays: 60,
      image: 'https://images.unsplash.com/photo-1516637090014-cb1ab78511f5?w=1200&q=80',
      description: 'Firefighter axe with the thin red line inlaid. Shipped March \'26 -- 180 pieces sold.',
      comments: 116,
      bookmarked: false,
    },
    {
      id: 'd12',
      title: 'Valknut Triptych',
      author: 'ironhand_carves',
      authorId: 'u2',
      category: 'Norse',
      status: 'New',
      votes: 27,
      threshold: 75,
      createdDays: 2,
      image: 'https://images.unsplash.com/photo-1568376794508-ae52c6ab3929?w=1200&q=80',
      description: 'Three-panel Valknut set. Separate pieces that form a larger pattern when hung together.',
      comments: 8,
      bookmarked: false,
    },
  ];

  const USERS = {
    u1: { id: 'u1', handle: 'you', display: 'You', joined: 'Feb 2026', points: 342, submissions: 3, votes: 94, bio: 'Workshop in the garage. Mostly walnut and red oak.' },
    u2: { id: 'u2', handle: 'ironhand_carves', display: 'Ironhand', joined: 'Aug 2025', points: 1840, submissions: 12, votes: 410, bio: 'Norse + celtic focus. Helgafell, OR.' },
    u3: { id: 'u3', handle: 'garage_goblin', display: 'Garage Goblin', joined: 'Nov 2024', points: 2915, submissions: 28, votes: 612, bio: 'Milling scraps into wall art since 2019.' },
    u4: { id: 'u4', handle: 'nordhammer', display: 'Nordhammer', joined: 'Mar 2025', points: 3280, submissions: 19, votes: 780, bio: 'Two-time design-of-the-month. Bergen transplant.' },
    u5: { id: 'u5', handle: 'pinecone_pete', display: 'Pinecone Pete', joined: 'Jan 2025', points: 1120, submissions: 9, votes: 288, bio: 'Rocky Mountain wildlife. Shavings everywhere.' },
    u6: { id: 'u6', handle: 'liberty_shop', display: 'Liberty Shop', joined: 'Jul 2024', points: 980, submissions: 7, votes: 311, bio: 'American flag work. Custom stars on request.' },
    u7: { id: 'u7', handle: 'rgr_woodworks', display: 'RGR Woodworks', joined: 'May 2024', points: 2405, submissions: 22, votes: 544, bio: '75th RRC vet. Tactical + military only.' },
    u8: { id: 'u8', handle: 'deadreckoning', display: 'Dead Reckoning', joined: 'Oct 2025', points: 640, submissions: 5, votes: 172, bio: 'Maritime skulls. Scrimshaw energy.' },
  };

  const COMMENTS = {
    d1: [
      { id: 'c1', authorId: 'u4', text: 'The runes read cleanly -- make sure the Ansuz stays upright in the bottom-left. I\u2019d push production toward walnut over maple.', hoursAgo: 6, likes: 14, fire: 3, replies: [
        { id: 'c1r1', authorId: 'u2', text: 'Good call. Swapping to walnut in the V2 render tonight.', hoursAgo: 5, likes: 5, fire: 0 },
      ] },
      { id: 'c2', authorId: 'u7', text: 'Would buy two. One for the shop, one for my brother in Tacoma.', hoursAgo: 11, likes: 22, fire: 7 },
      { id: 'c3', authorId: 'u5', text: 'Antler tips feel a little fragile for CNC -- might chip at high feed rates. Bigger fillets?', hoursAgo: 18, likes: 9, fire: 0 },
    ],
    d3: [
      { id: 'c4', authorId: 'u3', text: 'Been waiting on this one. Shipped to me when the numbered batch opens.', hoursAgo: 2, likes: 41, fire: 12 },
      { id: 'c5', authorId: 'u2', text: 'The shield overlap is perfect. How deep are you cutting the relief?', hoursAgo: 8, likes: 18, fire: 2 },
    ],
  };

  const FORUM = [
    { id: 'f1', title: 'Feed and speed for deep-relief walnut (3D carves)', authorId: 'u3', category: 'Shop Talk', replies: 34, hoursAgo: 3, pinned: true },
    { id: 'f2', title: 'Show & Tell -- March batch hangers', authorId: 'u7', category: 'Show & Tell', replies: 58, hoursAgo: 9 },
    { id: 'f3', title: 'Sourcing wide live-edge slabs in the PNW', authorId: 'u5', category: 'Questions', replies: 12, hoursAgo: 14 },
    { id: 'f4', title: 'Finishing schedule: torching vs oil for skulls', authorId: 'u8', category: 'Shop Talk', replies: 22, hoursAgo: 26 },
    { id: 'f5', title: 'Copyright on rune sets -- what\u2019s fair game?', authorId: 'u2', category: 'Questions', replies: 19, hoursAgo: 40 },
    { id: 'f6', title: 'Tips for stamped metadata engravings (monospace)', authorId: 'u4', category: 'Tips', replies: 8, hoursAgo: 52 },
  ];

  const ACTIVITY = [
    { type: 'vote', userId: 'u7', designId: 'd2', minsAgo: 2 },
    { type: 'comment', userId: 'u3', designId: 'd3', minsAgo: 6 },
    { type: 'submit', userId: 'u5', designId: 'd4', minsAgo: 18 },
    { type: 'threshold', designId: 'd3', minsAgo: 34 },
    { type: 'vote', userId: 'u2', designId: 'd1', minsAgo: 42 },
    { type: 'vote', userId: 'u4', designId: 'd7', minsAgo: 55 },
    { type: 'comment', userId: 'u8', designId: 'd1', minsAgo: 70 },
  ];

  return { CATS, STATUSES, DESIGNS, USERS, COMMENTS, FORUM, ACTIVITY };
})();

// Makers Directory -- 6 vetted fabricators across the US.
// Schema: id, name, initial, gradientHue, verified, featured, city, state,
//         description, rating, reviewCount, machines[], materials[], services[],
//         turnaround, experienceYears, priceTier (BUDGET|MID-RANGE|PREMIUM),
//         website, phone, email, reviews[]

window.KC_MAKERS = (() => {
  const MAKERS = [
    {
      id: 'm1',
      name: 'Ironhand Fabrication',
      initial: 'I',
      gradientHue: 18,
      verified: true,
      featured: true,
      city: 'Bend',
      state: 'Oregon',
      description: 'Full-service CNC and laser shop specializing in deep-relief walnut and figured hardwood. Two 4x8 routers, 150W CO2 laser, in-house finishing.',
      rating: 4.9,
      reviewCount: 47,
      machines: ['CNC Router', 'Laser'],
      materials: ['Walnut', 'White Oak', 'Cherry', 'Plywood', 'Acrylic'],
      services: ['Deep relief', 'Live edge', 'Custom inlay', 'Oil finishing'],
      turnaround: '1-2 weeks',
      experienceYears: 14,
      priceTier: 'PREMIUM',
      website: 'ironhandfab.com',
      phone: '(541) 555-0142',
      email: 'shop@ironhandfab.com',
      reviews: [
        { author: 'Ross M.', rating: 5, text: 'Flawless execution on a complex 3D relief carve. Grain alignment was perfect.' },
        { author: 'Hannah P.', rating: 5, text: 'Third order with Ironhand. Communication is top-tier. Always ships early.' },
        { author: 'Kyle D.', rating: 5, text: 'Worth every dollar. You can feel the experience in the tool paths.' },
        { author: 'Marisol V.', rating: 4, text: 'Finish work is beautiful. Slight lead time bump but kept me updated.' },
        { author: 'Aaron K.', rating: 5, text: 'They rebuilt my file for me when my CAD was off. Saved the project.' },
        { author: 'Pete S.', rating: 5, text: 'Best walnut I\u2019ve ever received from a maker. Repeat customer locked in.' },
      ],
    },
    {
      id: 'm2',
      name: 'Garage Goblin Works',
      initial: 'G',
      gradientHue: 32,
      verified: true,
      featured: true,
      city: 'Austin',
      state: 'Texas',
      description: 'Solo shop, scrap-mill specialist. Reclaimed lumber, live edge, and one-off wall pieces. Fast turnaround, honest pricing.',
      rating: 4.7,
      reviewCount: 28,
      machines: ['CNC Router', 'Laser'],
      materials: ['Reclaimed pine', 'Walnut', 'Live edge slabs', 'MDF'],
      services: ['Reclaimed lumber', 'Wall hangers', 'Bar-top inlays'],
      turnaround: '3-5 days',
      experienceYears: 7,
      priceTier: 'MID-RANGE',
      website: 'garagegoblin.works',
      phone: '(512) 555-0198',
      email: 'jake@garagegoblin.works',
      reviews: [
        { author: 'Tomas R.', rating: 5, text: 'Three-day turnaround on a 36" flag. Insane.' },
        { author: 'Bekah L.', rating: 4, text: 'Great value. Minor char on the laser edges but within spec for the price.' },
        { author: 'Derek Y.', rating: 5, text: 'Jake picked up the phone at 9pm to talk through file prep. Above and beyond.' },
        { author: 'Sami O.', rating: 5, text: 'Reclaimed pine looked incredible. You could smell the history.' },
      ],
    },
    {
      id: 'm3',
      name: 'Nordhammer Studio',
      initial: 'N',
      gradientHue: 8,
      verified: true,
      featured: false,
      city: 'Knoxville',
      state: 'Tennessee',
      description: 'Norse and Celtic motifs, stone-carved aesthetic. CNC + plasma combo for mixed-media pieces. No rush jobs.',
      rating: 4.8,
      reviewCount: 19,
      machines: ['CNC Router', 'Plasma'],
      materials: ['Oak', 'Steel plate', 'Cold-rolled', 'Blackened iron'],
      services: ['Rune work', 'Mixed media', 'Weathered finishes'],
      turnaround: '2-3 weeks',
      experienceYears: 11,
      priceTier: 'PREMIUM',
      website: 'nordhammerstudio.com',
      phone: '(865) 555-0173',
      email: 'magnus@nordhammerstudio.com',
      reviews: [
        { author: 'Freya W.', rating: 5, text: 'The steel-and-oak valknut piece is a family heirloom now. Magnus is an artist.' },
        { author: 'Ivan B.', rating: 5, text: 'Heavy. Both the piece and the presence it has in a room.' },
        { author: 'Clair N.', rating: 4, text: 'Slow lead time, but they were upfront about it from day one.' },
      ],
    },
    {
      id: 'm4',
      name: 'Liberty Shop Co.',
      initial: 'L',
      gradientHue: 14,
      verified: false,
      featured: false,
      city: 'Tampa',
      state: 'Florida',
      description: 'American flag specialists. Custom stars, union layouts, and tattered/weathered effects. Veteran-owned.',
      rating: 4.5,
      reviewCount: 23,
      machines: ['Laser'],
      materials: ['Baltic birch', 'Poplar', 'Plywood'],
      services: ['Custom stars', 'Tattered edges', 'Stain matching'],
      turnaround: '1 week',
      experienceYears: 5,
      priceTier: 'BUDGET',
      website: 'libertyshop.co',
      phone: '(813) 555-0117',
      email: 'orders@libertyshop.co',
      reviews: [
        { author: 'Reggie F.', rating: 5, text: 'Sent a photo of my dad\u2019s unit patch and they laser-carved the stars layout. Gift of a lifetime.' },
        { author: 'Alma G.', rating: 4, text: 'Solid work for the price. Ships fast.' },
        { author: 'Quentin H.', rating: 5, text: 'Veteran-owned, respectful, and they take the work seriously.' },
      ],
    },
    {
      id: 'm5',
      name: 'Pinecone Pete',
      initial: 'P',
      gradientHue: 24,
      verified: false,
      featured: false,
      city: 'Estes Park',
      state: 'Colorado',
      description: 'Rocky Mountain wildlife scenes. CNC, laser, and small-batch 3D printed accents for mixed dimensional work.',
      rating: 4.4,
      reviewCount: 15,
      machines: ['CNC Router', 'Laser', '3D Printer'],
      materials: ['Pine', 'Aspen', 'Cedar', 'PLA accents'],
      services: ['Wildlife scenes', '3D dimensional work', 'Nature inlays'],
      turnaround: '2 weeks',
      experienceYears: 6,
      priceTier: 'MID-RANGE',
      website: 'pineconepete.com',
      phone: '(970) 555-0155',
      email: 'pete@pineconepete.com',
      reviews: [
        { author: 'Whitney A.', rating: 5, text: 'The 3D elk piece is incredible. The antlers stand off the wood.' },
        { author: 'Jose M.', rating: 4, text: 'Fun to work with. Pete texts progress photos unprompted.' },
      ],
    },
    {
      id: 'm6',
      name: 'RGR Woodworks',
      initial: 'R',
      gradientHue: 5,
      verified: true,
      featured: false,
      city: 'San Angelo',
      state: 'Texas',
      description: '75th RRC vet running a tight shop. Military and tactical designs only. CNC mill for precision detail work, plus router and plasma.',
      rating: 4.9,
      reviewCount: 34,
      machines: ['CNC Router', 'CNC Mill', 'Plasma'],
      materials: ['Walnut', 'Steel', 'Aluminum', 'G10'],
      services: ['Military work', 'Tactical', 'Unit pieces', 'Precision detail'],
      turnaround: '1-2 weeks',
      experienceYears: 9,
      priceTier: 'MID-RANGE',
      website: 'rgrwoodworks.com',
      phone: '(325) 555-0184',
      email: 'ryan@rgrwoodworks.com',
      reviews: [
        { author: 'Mason T.', rating: 5, text: 'Detail on the unit crest was beyond what I hoped for.' },
        { author: 'Elena K.', rating: 5, text: 'Ryan gets it. Clean lines, no BS, delivers what he promises.' },
        { author: 'Dale V.', rating: 5, text: 'Ordered three. All three perfect.' },
        { author: 'Trev B.', rating: 4, text: 'Slight backlog but absolutely worth the wait.' },
      ],
    },
    {
      id: 'm7',
      name: 'Blacksmith Bros',
      initial: 'B',
      gradientHue: 15,
      verified: true,
      featured: true,
      city: 'Pittsburgh',
      state: 'Pennsylvania',
      description: 'Steel + hardwood mixed media. Industrial aesthetic, heavy-duty finishes. Two-brother team with 20+ combined years in fabrication.',
      rating: 4.8,
      reviewCount: 41,
      machines: ['CNC Router', 'Plasma', 'Laser'],
      materials: ['Hot-rolled steel', 'Walnut', 'White oak', 'Corten'],
      services: ['Industrial finishes', 'Weathered steel', 'Riveted accents'],
      turnaround: '1-2 weeks',
      experienceYears: 20,
      priceTier: 'MID-RANGE',
      website: 'blacksmithbros.co',
      phone: '(412) 555-0221',
      email: 'shop@blacksmithbros.co',
      reviews: [
        { author: 'Nina W.', rating: 5, text: 'Corten steel + walnut piece aged gorgeously. Exactly what I asked for.' },
        { author: 'Ben J.', rating: 5, text: 'These guys know metal. The rivets alone sold me.' },
        { author: 'Cara S.', rating: 4, text: 'Communication could be faster but the work speaks for itself.' },
      ],
    },
    {
      id: 'm8',
      name: 'High Desert Carving',
      initial: 'H',
      gradientHue: 22,
      verified: false,
      featured: false,
      city: 'Flagstaff',
      state: 'Arizona',
      description: 'Southwestern motifs, desert wildlife, and petroglyph-inspired work. Cedar specialist with a focus on scorched finishes.',
      rating: 4.6,
      reviewCount: 18,
      machines: ['CNC Router', 'Laser'],
      materials: ['Cedar', 'Juniper', 'Mesquite', 'Pine'],
      services: ['Shou sugi ban', 'Petroglyph work', 'Southwestern motifs'],
      turnaround: '2 weeks',
      experienceYears: 8,
      priceTier: 'MID-RANGE',
      website: 'highdesertcarving.com',
      phone: '(928) 555-0143',
      email: 'hello@highdesertcarving.com',
      reviews: [
        { author: 'Elena P.', rating: 5, text: 'The scorched cedar smells incredible. Piece feels ancient.' },
        { author: 'Mick L.', rating: 4, text: 'Great work, a little slow to respond initially.' },
      ],
    },
    {
      id: 'm9',
      name: 'Birchwood Fab',
      initial: 'B',
      gradientHue: 30,
      verified: true,
      featured: false,
      city: 'Asheville',
      state: 'North Carolina',
      description: 'Appalachian hardwoods, multi-layer relief specialist. Known for botanical and flora work with precise layering.',
      rating: 4.9,
      reviewCount: 52,
      machines: ['CNC Router', 'Laser'],
      materials: ['Maple', 'Cherry', 'Walnut', 'Poplar'],
      services: ['Multi-layer relief', 'Botanicals', 'Custom matting'],
      turnaround: '2-3 weeks',
      experienceYears: 12,
      priceTier: 'PREMIUM',
      website: 'birchwoodfab.com',
      phone: '(828) 555-0167',
      email: 'orders@birchwoodfab.com',
      reviews: [
        { author: 'Sara H.', rating: 5, text: 'The fern piece has 7 layers. Seven. You can count the leaves.' },
        { author: 'Tom B.', rating: 5, text: 'Worth every penny. I will be back.' },
        { author: 'Gina F.', rating: 5, text: 'Exquisite detail work. Heirloom quality.' },
      ],
    },
    {
      id: 'm10',
      name: 'Sawdust Republic',
      initial: 'S',
      gradientHue: 28,
      verified: false,
      featured: false,
      city: 'Portland',
      state: 'Maine',
      description: 'Nautical and coastal designs. Cedar, pine, and reclaimed shipyard lumber. Fast turnaround for a small shop.',
      rating: 4.4,
      reviewCount: 22,
      machines: ['Laser', 'CNC Router'],
      materials: ['Cedar', 'Pine', 'Reclaimed shipyard', 'Baltic birch'],
      services: ['Nautical charts', 'Coastal scenes', 'Rope inlays'],
      turnaround: '1 week',
      experienceYears: 6,
      priceTier: 'BUDGET',
      website: 'sawdustrepublic.com',
      phone: '(207) 555-0189',
      email: 'sam@sawdustrepublic.com',
      reviews: [
        { author: 'Jay R.', rating: 5, text: 'Nautical chart piece is stunning. Smells like the coast.' },
        { author: 'Pia T.', rating: 4, text: 'Fast and affordable. Hard to beat.' },
        { author: 'Kara E.', rating: 4, text: 'Good value. Minor rope inlay alignment issue but Sam fixed it.' },
      ],
    },
    {
      id: 'm11',
      name: 'Copper Canyon Works',
      initial: 'C',
      gradientHue: 10,
      verified: true,
      featured: false,
      city: 'Boise',
      state: 'Idaho',
      description: 'Mixed media with copper accents, patina finishes, and walnut base. Small-batch production.',
      rating: 4.7,
      reviewCount: 29,
      machines: ['CNC Router', 'Laser', 'Plasma'],
      materials: ['Copper', 'Walnut', 'Brass', 'Patina'],
      services: ['Copper inlay', 'Patina aging', 'Mixed media'],
      turnaround: '2-3 weeks',
      experienceYears: 10,
      priceTier: 'PREMIUM',
      website: 'coppercanyonworks.com',
      phone: '(208) 555-0134',
      email: 'info@coppercanyonworks.com',
      reviews: [
        { author: 'Max V.', rating: 5, text: 'The copper patina is a work of art on its own.' },
        { author: 'Lee D.', rating: 5, text: 'Premium pricing, premium execution.' },
        { author: 'Tina O.', rating: 4, text: 'Gorgeous but took longer than quoted.' },
      ],
    },
    {
      id: 'm12',
      name: 'Thunderhead Studios',
      initial: 'T',
      gradientHue: 5,
      verified: true,
      featured: true,
      city: 'Bozeman',
      state: 'Montana',
      description: 'Big-sky landscapes, mountain silhouettes, and bison scenes. Full-size 5x10 router for large-format wall pieces.',
      rating: 4.9,
      reviewCount: 38,
      machines: ['CNC Router', 'Laser'],
      materials: ['Oak', 'Walnut', 'Aspen', 'Black walnut'],
      services: ['Large format', 'Landscape scenes', 'Western themes'],
      turnaround: '2 weeks',
      experienceYears: 13,
      priceTier: 'PREMIUM',
      website: 'thunderheadstudios.com',
      phone: '(406) 555-0178',
      email: 'shop@thunderheadstudios.com',
      reviews: [
        { author: 'Anna K.', rating: 5, text: 'My 6-foot mountain scene arrived in a crate. Worth the freight.' },
        { author: 'Rob N.', rating: 5, text: 'Large-format work is their specialty and it shows.' },
        { author: 'Jen M.', rating: 5, text: 'Bison piece is the centerpiece of our living room now.' },
      ],
    },
    {
      id: 'm13',
      name: 'Iron Horse Fab',
      initial: 'I',
      gradientHue: 0,
      verified: false,
      featured: false,
      city: 'Chattanooga',
      state: 'Tennessee',
      description: 'Railroad nostalgia, steampunk aesthetic. Gears, cogs, and brass accents. Husband-wife team, small but passionate.',
      rating: 4.5,
      reviewCount: 14,
      machines: ['Laser', 'Plasma'],
      materials: ['Brass', 'Steel', 'Pine', 'Plywood'],
      services: ['Steampunk', 'Gear inlays', 'Railroad motifs'],
      turnaround: '1-2 weeks',
      experienceYears: 5,
      priceTier: 'MID-RANGE',
      website: 'ironhorsefab.com',
      phone: '(423) 555-0156',
      email: 'ironhorse@gmail.com',
      reviews: [
        { author: 'Vic P.', rating: 5, text: 'Steampunk gear clock is a showstopper.' },
        { author: 'Dee R.', rating: 4, text: 'Fun pieces, creative design input welcome.' },
      ],
    },
    {
      id: 'm14',
      name: 'Prairie Wood Co.',
      initial: 'P',
      gradientHue: 35,
      verified: false,
      featured: false,
      city: 'Lincoln',
      state: 'Nebraska',
      description: 'Heartland aesthetic. Farm, wheat, and homestead designs. Budget-friendly for volume orders and wedding parties.',
      rating: 4.3,
      reviewCount: 31,
      machines: ['Laser'],
      materials: ['Pine', 'Plywood', 'Baltic birch'],
      services: ['Wedding signs', 'Farm themes', 'Volume orders'],
      turnaround: '3-5 days',
      experienceYears: 4,
      priceTier: 'BUDGET',
      website: 'prairiewoodco.com',
      phone: '(402) 555-0112',
      email: 'orders@prairiewoodco.com',
      reviews: [
        { author: 'Linda H.', rating: 5, text: 'Made 40 wedding favors in 4 days. Pricing was unbeatable.' },
        { author: 'Scott G.', rating: 4, text: 'Great for volume. Budget-tier finishes, which is what I paid for.' },
        { author: 'Amy B.', rating: 4, text: 'Clean laser work. Happy customer.' },
      ],
    },
    {
      id: 'm15',
      name: 'Summit Metal & Wood',
      initial: 'S',
      gradientHue: 12,
      verified: true,
      featured: false,
      city: 'Denver',
      state: 'Colorado',
      description: 'Alpine themes, climbing and skiing motifs. Mixed steel and walnut construction. Lifetime warranty on all pieces.',
      rating: 4.8,
      reviewCount: 26,
      machines: ['CNC Router', 'CNC Mill', 'Laser', 'Plasma'],
      materials: ['Walnut', 'Cold-rolled steel', 'Aluminum', 'Titanium'],
      services: ['Alpine motifs', 'Outdoor themes', 'Lifetime warranty'],
      turnaround: '2 weeks',
      experienceYears: 11,
      priceTier: 'PREMIUM',
      website: 'summitmw.com',
      phone: '(303) 555-0201',
      email: 'info@summitmw.com',
      reviews: [
        { author: 'Erik S.', rating: 5, text: 'Ice-axe motif piece hangs in my gear room. Perfect.' },
        { author: 'Hana L.', rating: 5, text: 'Lifetime warranty is the real deal -- they replaced a piece after a flood.' },
        { author: 'Drew C.', rating: 4, text: 'High quality but lead time was longer than expected.' },
      ],
    },
  ];

  return { MAKERS };
})();
